/* @flow */

export const ERROR_CODE = {
    VALIDATION_ERROR: ('validation_error' : 'validation_error')
};
